import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateItpPayload } from '@app-store/slices/companies/createItp'

interface TaskAction extends Action {
    payload: ICreateItpPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.companies.createItp

function* createItpSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/itps`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createItpSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createItpSagaTask)
}

export default createItpSaga
